import { api } from './api'

export const apiVehicle = {

    getCars: (filter, page, size = 10) => api.post('web/vehicles/filter', { filter, page, size }),

    getCarOptions: (params) => {
        return api.get('web/vehicles/create_vehicle_options', { ...params })
    },

    getCarFilterOptions: () => {
        return api.get('web/vehicles/filter_options')
    },

    createNewCar: (params) => {
        return api.post('web/vehicles/create', { ...params })
    },

    updateCar: (params) => {
        return api.put('web/vehicles/update', { ...params })
    },

    deleteCar: (id) => {
        return api.delete(`web/vehicles/delete/${id}`)
    },
    exportVehicle: async (filter, page, size, fileName = 'Danh sách xe') => {
        return await api.postExcel('web/export/vehicles', { filter, page, size, fileName })
    }
}
